module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNDcuMjkxIiBoZWlnaHQ9IjI4Mi4xMDIiIHZpZXdCb3g9IjAgMCAyNDcuMjkxIDI4Mi4xMDIiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0NyIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0NyIgZD0iTTUxNy4yMzIsMTE1MS42NFY5NjMuMjYzbDI0Ny4yOTEtOTMuNzI3djE4OC4zNzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE3LjIzMSAtODY5LjUzNykiIGZpbGw9ImJsdWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/blue_247.svg
// module id = v3aJ
// module chunks = 0